module.exports = __webpack_public_path__ + "static/img/y7.9dd47ffe.svg";